import Cookies from 'js-cookie';
import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function getCityStateFromCoordinates(lat, lon) {
  try {
    loginfo();
    return await apiClient.post('/getCityandStateAtCoordinate/', {
      long: lon,
      lat: lat,
    });
  } catch (error) {
    console.error('getCityandStateAtCoordinate failed.', error);
  }
}

export async function autoCompleteSearch(latitude, longitude, term) {
  try {
    loginfo();
    return await apiClient.post('/googleAutocompleteSearch', {
      latitude,
      longitude,
      term,
    });
  } catch (error) {
    console.error('googleAutocompleteSearch failed.', error);
  }
}

export async function informLocationChange(location) {
  try {
    loginfo();
    return await apiClient.post('/informLocationChange', { location });
  } catch (error) {
    console.error('informLocationChange failed.', error);
  }
}

export async function connectToIsDataReadyForLocation(location) {
  const country = location.place_data.address_components.find(
    (item) => item.types[0] === 'country',
  ).short_name;

  const locationInfo = {
    city: location.city,
    state_long: location.state_long,
    term: location.term,
    latitude: location.latitude,
    longitude: location.longitude,
    country: country,
  };
  try {
    loginfo();
    const url = `${process.env.PUBLIC_API_URL}/live-location-ready?token=${encodeURIComponent(
      Cookies.get('accessToken'),
    )}}&location=${JSON.stringify(locationInfo)}`;

    return new EventSource(url);
  } catch (e) {
    throw e;
  }
}
